<template>
  <div>
    <template v-if="canVerb(resource, 'index')">
      <actions-toolbar>
        <template #filters>
          <div class="status-filter">
            <!-- <p style="display: flex; align-items: center; gap: 5px">
              <span style="font-size: 14px; font-weight: 500">Filtri</span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                width="18"
              >
                <path
                  d="M960 682.7H527.3c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h134c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112s127.6-47.8 144-112c2.4-9.4 10.9-16 20.7-16h432.7c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3zm-597.3 128c-58.9 0-106.6-47.8-106.6-106.7s47.7-106.6 106.6-106.6 106.6 47.8 106.6 106.7-47.7 106.6-106.6 106.6zm298.6-341.4c69.4 0 127.6-47.8 144-112 2.4-9.4 10.9-16 20.7-16h134c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3H826c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h432.7c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112h0zm0-256c58.9 0 106.7 47.8 106.7 106.7s-47.8 106.7-106.7 106.7S554.6 378.9 554.6 320s47.8-106.7 106.7-106.7h0z"
                ></path>
              </svg>
            </p> -->
            <!-- <pre>{{ activeFilters }}</pre> -->
            <!-- v-for="(value, name, index) in computeActiveFilters" -->
            <div class="pill-wrapper my-3">
              <span
                class="pill"
                v-for="(value, name, index) in activeFilters"
                :key="index"
                data-color="white"
              >
                <span v-b-toggle.sidebar-1 :data-filter="name"
                  ><strong>{{ sidebarFilterName(name) }}</strong
                  >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                >
                <span tabindex="0">
                  <span
                    @click="resetSingleSidebarFilter(name)"
                    title="Rimuovi filtro"
                    >×</span
                  >
                </span>
              </span>
              <template v-if="countActiveFilters">
                <span
                  class="pill"
                  data-color="alert"
                  @click="resetAllFilters()"
                  title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                >
                  <span
                    ><strong>Reset ({{ countActiveFilters }})</strong></span
                  >
                  <span><span>×</span></span>
                </span>
              </template>
            </div>
          </div>
        </template>
        <b-button-group
          v-b-toggle.sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countActiveFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">{{
            computedFilterTitle
          }}</span>
        </b-button-group>
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            {
              code: 'EXPOAGCO',
              label: null,
              formats: ['csv', 'pdf'],
            },
          ]"
        ></export-options>
        <b-button
          class="btn btn--create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="onAdd"
          title="Crea un nuovo contatto"
          v-if="canVerb(resource, 'store')"
        >
          <base-icon name="circled_plus" width="22" height="22" />
          <span>Crea</span>
        </b-button>
      </actions-toolbar>
      <div class="table-container">
        <b-sidebar
          id="sidebar-1"
          :title="computedFilterTitle"
          :backdrop="true"
          width="50dvw"
          shadow
          right
          :visible="open_filter"
          :data-open="open_filter"
          @change="onSidebarFilterChange"
        >
          <template #header="{ hide }">
            <div class="inner-header">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea un nuovo contatto </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAdd"
                  title="Crea un nuovo contatto"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </div>
          </template>
          <b-form @submit.prevent="onSearch(filterName)">
            <div class="filter">
              <div class="filter-item">
                <base-input
                  name="AGFRNAME"
                  v-model="filter.byCustom.title.value"
                  type="text"
                  label="Nominativo"
                  placeholder="Inserisci un nominativo"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-input
                  name="NINO"
                  v-model="filter.byAttribute.NINO"
                  type="text"
                  label="Codice Fiscale"
                  placeholder="Inserisci un codice fiscale"
                />
                <base-input
                  name="CREG"
                  v-model="filter.byAttribute.CREG"
                  type="text"
                  label="Partita IVA"
                  placeholder="Inserisci una partita IVA"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="CLI"
                  label="Cliente"
                  v-model="filter.byAttribute.CLI"
                  :options="opt_sup_cli"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
                <base-select
                  name="SUP"
                  label="Fornitore"
                  v-model="filter.byAttribute.SUP"
                  :options="opt_sup_cli"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
              </div>
              <!-- <b-button-group
                v-b-toggle:collapse-1-inner
                class="my-2 filter-button-group"
              >
                <span class="when-open">
                  <b-icon icon="funnel" font-scale="1.5"></b-icon>
                </span>
                <span class="when-closed">
                  <b-icon icon="funnel" font-scale="1.5"></b-icon>
                </span>
                Altri Filtri
              </b-button-group>
              <b-collapse id="collapse-1-inner" class="mt-2">
              </b-collapse> -->
              <h3 class="inner-filter-title mt-5">Filtri aggiuntivi</h3>
              <div class="filter-item" data-cols="2">
                <base-input
                  name="PHON"
                  v-model="filter.byAddressBook.PHON"
                  type="text"
                  label="Telefono"
                  placeholder="Inserisci un numero di telefono"
                />
                <base-input
                  name="CELL"
                  v-model="filter.byAddressBook.CELL"
                  type="text"
                  label="Cellulare"
                  placeholder="Inserisci un numero di cellulare"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-input
                  name="FAX"
                  v-model="filter.byAddressBook.FAX"
                  type="text"
                  label="Fax"
                  placeholder="Inserisci un fax"
                />
                <base-input
                  name="MAIL"
                  v-model="filter.byAddressBook.MAIL"
                  type="text"
                  label="Email"
                  placeholder="Inserisci una mail"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="PROVINCE"
                  label="Provincia"
                  v-model="filter.province"
                  :options="opt_provinces"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                  @select="onSelectProvince"
                  @remove="onRemoveProvince"
                />
                <base-select
                  name="CITY"
                  label="Comune"
                  v-model="filter.byCorrespondence.CITY"
                  :options="opt_councils"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
              </div>
              <div class="filter-item">
                <base-input
                  name="CAP"
                  v-model="filter.byCorrespondence.ZIPC"
                  type="text"
                  label="CAP"
                  maxlength="5"
                  placeholder="Inserisci un CAP"
                />
              </div>
              <div class="filter-item">
                <base-textarea
                  name="ADDR"
                  label="Indirizzo"
                  v-model="filter.byCorrespondence.ADDR"
                  placeholder="Inserisci un indirizzo"
                />
              </div>
              <div class="mt-5" v-show="customFilters.length > 0">
                <h3 class="inner-filter-title">Filtri su campi aggiuntivi</h3>
                <p>Attributi personalizzati</p>
                <div v-for="(element, index) in customFilters" :key="index">
                  <custom-filter
                    v-model="filter.byAttribute[element.key]"
                    :element="element"
                  />
                </div>
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca</b-button
              >
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset</b-button
              >
            </div>
          </b-form>
        </b-sidebar>
        <table-agency-contacts
          @edit="onEdit"
          @manualFetch="manualFetch"
          :fields="fields"
          :repository="repository"
          :resource="resource"
          :filterName="filterName"
          :ref="tableRef"
          :performedSearch="computePerformedSearch"
          :filterCount="countActiveFilters"
          :filterOn="{
            byRelations: [
              'byCorrespondence',
              'byAddressBook',
              'byDocument',
              'byTask',
            ],
          }"
          :onlyActions="['edit', 'destroy', 'infomodal']"
          @destroy="onDestroy"
        ></table-agency-contacts>
      </div>
    </template>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import ExportOptions from "@/components/ExportOptions";
import TableAgencyContacts from "@/components/tables/AgencyContactsWallet";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseTextarea from "@/components/form/BaseTextarea";
import CustomFilter from "@/components/form/CustomFilter";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters, mapActions } from "vuex";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      repository: "agency_contact",
      resource: "agency_contacts",
      filterName: "filterAgencyContact",
      notes: [],
      todos: [],
      appointments: [],
      documents: [],
      filter: this.initFilter(),
      defaultCountryName: "Italia",
      opt_councils: [],
      opt_provinces: [],
      opt_sup_cli: [
        { text: "Si", value: "Y" },
        { text: "No", value: "N" },
      ],
      opt_agency_contacts_type: [
        { value: "0", text: "Cliente" },
        { value: "1", text: "Fornitore" },
        { value: "2", text: "Fornitore/Cliente" },
      ],
      tableRef: "AgencyContactTableRef",
      activeFilters: {},
      performedSearch: false,
      fields: [
        {
          key: "attributables.CNAM",
          value: "attributables.CNAM",
          label: this.getDictionary("attribute_CNAM_value", "agency_contact"),
          sortable: true,
          sortKey: "CNAM",
          formatter: (value) => value ?? "-",
        },
        {
          key: "attributables.NAME",
          value: "attributables.NAME",
          label: this.getDictionary("attribute_NAME_value", "agency_contact"),
          sortable: true,
          sortKey: "NAME",
          formatter: (value) => value ?? "-",
        },
        {
          key: "attributables.SURN",
          value: "attributables.SURN",
          label: this.getDictionary("attribute_SURN_value", "agency_contact"),
          sortable: true,
          sortKey: "SURN",
          formatter: (value) => value ?? "-",
        },
        {
          key: "attributables.NINO",
          value: "attributables.NINO",
          label: this.getDictionary("attribute_NINO_value", "agency_contact"),
          sortable: true,
          sortKey: "NINO",
          formatter: (value) => value ?? "-",
        },
        {
          key: "attributables.CREG",
          value: "attributables.CREG",
          label: this.getDictionary("attribute_CREG_value", "agency_contact"),
          sortable: true,
          sortKey: "CREG",
          formatter: (value) => value ?? "-",
        },
        {
          key: "city",
          label: this.getDictionary("city", "agency_contact"),
        },
        {
          key: "province",
          label: this.getDictionary("province", "agency_contact"),
        },
        {
          key: "phone",
          label: this.getDictionary("phone", "agency_contact"),
        },
        {
          key: "cellphone",
          label: this.getDictionary("cell", "agency_contact"),
        },
        {
          key: "mail",
          label: this.getDictionary("email", "agency_contact"),
        },
        {
          key: "attributables.CLI",
          label: this.getDictionary("attribute_CLI_value", "agency_contact"),
          formatter: (value) => {
            return value === "Y" ? "Si" : "No";
          },
        },
        {
          key: "attributables.SUP",
          label: this.getDictionary("attribute_SUP_value", "agency_contact"),
          formatter: (value) => {
            return value === "Y" ? "Si" : "No";
          },
        },
        {
          key: "document_counter",
          label: this.getDictionary("Documenti"),
          value: (item) => (item.documents ? item.documents.length : 0),
        },
        {
          key: "note_counter",
          label: this.getDictionary("Note"),
          value: (item) =>
            item.tasks
              ? item.tasks.filter((task) => task.task_type.value === 2).length
              : 0,
        },
        {
          key: "todo_counter",
          label: this.getDictionary("Attività"),
          value: (item) =>
            item.tasks.length
              ? item.tasks.filter((task) => task.task_type.value === 1).length
              : 0,
          sortable: false,
        },
        {
          key: "appointment_counter",
          label: this.getDictionary("Appuntamenti"),
          value: (item) =>
            item.tasks.length
              ? item.tasks.filter((task) => task.task_type.value === 0).length
              : 0,
          sortable: false,
        },
      ],
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    TableAgencyContacts,
    // ButtonGroupTable,
    ExportOptions,
    BaseSelect,
    CustomFilter,
    BaseTextarea,
  },
  methods: {
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    computeFilterName(name) {
      // return this.filterLabels[name];
      if (!name) return "-";
      return this.getDictionary(name, "filters");
    },
    computeFilterValue(name, value) {
      // return this.filterLabels[name];
      /* */
      let ret;
      switch (name) {
        case "byAttribute.status_registry":
          ret = this.statusRegistryOptions.find(
            (el) => el.value === value,
          ).text;
          break;
        case "byBroker.id":
          if (isNaN(value)) {
            ret = value;
          } else {
            ret = this.salesmen.find((el) => el.value === value).text;
          }
          break;
        default:
          ret = "";
          break;
      }
      /* */
      if (!ret && !name) return "-";
      if (ret) return ret;
      ret = this.getDictionary(`${name}.${value}`, "filters");
      return ret ? ret : value;
    },
    // clearSingleFilter(result, parentLevel, lastKey) {
    // clearSingleFilter(parts) {
    //   debugger;
    //   if (!parts || !parts?.length) return;

    //   // if (!result || !parentLevel || !lastKey) return;
    //   // parentLevel[lastKey] = null;
    // },
    resetSingleFilter(name) {
      // debugger;
      let res = true;
      // Split the string into parts by the `dot`
      const parts = name.split(".");

      // Traverse the allowedKeys object according to the parts
      // let currentLevel = this.filter;
      // let parentLevel = null;
      // let lastKey = null;

      // for (const part of parts) {
      //   // Check if the current part exists in the current level
      //   if (!currentLevel || !(part in currentLevel)) {
      //     res = false; // Part is not valid
      //   }
      //   parentLevel = currentLevel; // Save the current level for modification
      //   lastKey = part; // Save the current key
      //   currentLevel = currentLevel[part]; // Move to the next level
      // }

      // this.clearSingleFilter(res, parentLevel, lastKey);

      // Set the value to null at the final level
      // if (parentLevel && lastKey) {
      //   parentLevel[lastKey] = null;
      // }

      // return true; // All parts are valid

      // // Traverse the allowedKeys object according to the parts
      let currentLevel = this.filter;
      for (const part of parts) {
        // Check if the current part exists in the current level
        if (!currentLevel || !(part in currentLevel)) {
          res = false; // Part is not valid
        }
        currentLevel = currentLevel[part]; // Move to the next level
      }
      // debugger;

      // res = true; // All parts are valid
      if (!res) return;
      // this.clearSingleFilter(parts);
      // const splitted = this.splitByLastDot(name);
      // if (!splitted.length) return;
      this.accessNestedFilterOption(name);
      // const access = this.accessNestedFilterOption(splitted);
      // console.log(access);
      // if (!access || !Object.keys(access).length) return;
      // // debugger;
      // access[splitted[1]] = null;

      // console.log("res", res);
    },
    splitByLastDot(str) {
      const lastDotIndex = str.lastIndexOf(".");
      if (lastDotIndex === -1) {
        return [str]; // No dots found, return the whole string
      }
      return [str.slice(0, lastDotIndex), str.slice(lastDotIndex + 1)];
    },
    accessNestedFilterOption(name) {
      const splitted = this.splitByLastDot(name);
      if (!splitted.length) return;
      const access = splitted[0].split(".").reduce((o, i) => o[i], this.filter);
      if (!access || !Object.keys(access).length) return;
      access[splitted[1]] = null;
      console.log("this.filter", this.filter);
      console.log("access", access);
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      this.onSearch(this.filterName);
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    initFilter() {
      let init = {
        province: null,
        byAttribute: {
          status_agencycontact: null,
          NAME: null,
          SURN: null,
          CNAM: null,
          NINO: null,
          CREG: null,
          CLI: null,
          SUP: null,
        },
        byCustom: {
          title: {
            value: null,
            likewise: 1,
            filter: "byAttribute",
          },
        },
        byAddressBook: {
          CELL: null,
          PHON: null,
          FAX: null,
          MAIL: null,
        },
        byCorrespondence: {
          CITY: null,
          ADDR: null,
          ZIPC: null,
        },
      };
      return init;
    },
    onEdit(id, item) {
      this.$router.push({
        name: `${this.resource}.edit0`,
        params: { id: `${id}`, item: item },
      });
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create0` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Contatto di agenzia eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSelectProvince(selected) {
      this.opt_councils = this.councils()(selected);
      this.filter.byCorrespondence.CITY = null;
    },
    onRemoveProvince() {
      this.opt_councils = [];
      this.filter.byCorrespondence.CITY = null;
    },
    onSearch(name) {
      this.performedSearch = true;
      /* */
      // this.activeFilters = this.computeActiveFilters;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      /* */
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapGetters("auth", ["provinces", "councils", "countries"]),
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computeActiveFilters() {
      return this.retriveActiveFilters();
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  created() {
    const defaultCountryId = this.countries().find(
      (country) => country.text == this.defaultCountryName,
    ).value;
    this.opt_provinces = this.provinces()(defaultCountryId);
  },
  mounted() {
    this.activeFilters = {};
    this.activeFilters = this.retriveActiveFilters();
    this.open_filter = this.areActiveFiltersOnlyDefault();
  },
};
</script>
